/**
 * @fileoverview gRPC-Web generated client stub for marginpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: marginpb/requirement.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.marginpb = require('./requirement_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.marginpb.RequirementServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.marginpb.RequirementServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.ListRequirementRequest,
 *   !proto.marginpb.ListRequirementResponse>}
 */
const methodDescriptor_RequirementService_ListRequirement = new grpc.web.MethodDescriptor(
  '/marginpb.RequirementService/ListRequirement',
  grpc.web.MethodType.UNARY,
  proto.marginpb.ListRequirementRequest,
  proto.marginpb.ListRequirementResponse,
  /**
   * @param {!proto.marginpb.ListRequirementRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListRequirementResponse.deserializeBinary
);


/**
 * @param {!proto.marginpb.ListRequirementRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.marginpb.ListRequirementResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.ListRequirementResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.RequirementServiceClient.prototype.listRequirement =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/marginpb.RequirementService/ListRequirement',
      request,
      metadata || {},
      methodDescriptor_RequirementService_ListRequirement,
      callback);
};


/**
 * @param {!proto.marginpb.ListRequirementRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.ListRequirementResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.RequirementServicePromiseClient.prototype.listRequirement =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/marginpb.RequirementService/ListRequirement',
      request,
      metadata || {},
      methodDescriptor_RequirementService_ListRequirement);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.ListRequirementDetailRequest,
 *   !proto.marginpb.ListRequirementDetailResponse>}
 */
const methodDescriptor_RequirementService_ListRequirementDetail = new grpc.web.MethodDescriptor(
  '/marginpb.RequirementService/ListRequirementDetail',
  grpc.web.MethodType.UNARY,
  proto.marginpb.ListRequirementDetailRequest,
  proto.marginpb.ListRequirementDetailResponse,
  /**
   * @param {!proto.marginpb.ListRequirementDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListRequirementDetailResponse.deserializeBinary
);


/**
 * @param {!proto.marginpb.ListRequirementDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.marginpb.ListRequirementDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.ListRequirementDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.RequirementServiceClient.prototype.listRequirementDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/marginpb.RequirementService/ListRequirementDetail',
      request,
      metadata || {},
      methodDescriptor_RequirementService_ListRequirementDetail,
      callback);
};


/**
 * @param {!proto.marginpb.ListRequirementDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.ListRequirementDetailResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.RequirementServicePromiseClient.prototype.listRequirementDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/marginpb.RequirementService/ListRequirementDetail',
      request,
      metadata || {},
      methodDescriptor_RequirementService_ListRequirementDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.StreamRequirementRequest,
 *   !proto.marginpb.Requirement>}
 */
const methodDescriptor_RequirementService_StreamRequirement = new grpc.web.MethodDescriptor(
  '/marginpb.RequirementService/StreamRequirement',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.marginpb.StreamRequirementRequest,
  proto.marginpb.Requirement,
  /**
   * @param {!proto.marginpb.StreamRequirementRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.Requirement.deserializeBinary
);


/**
 * @param {!proto.marginpb.StreamRequirementRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.Requirement>}
 *     The XHR Node Readable Stream
 */
proto.marginpb.RequirementServiceClient.prototype.streamRequirement =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/marginpb.RequirementService/StreamRequirement',
      request,
      metadata || {},
      methodDescriptor_RequirementService_StreamRequirement);
};


/**
 * @param {!proto.marginpb.StreamRequirementRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.Requirement>}
 *     The XHR Node Readable Stream
 */
proto.marginpb.RequirementServicePromiseClient.prototype.streamRequirement =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/marginpb.RequirementService/StreamRequirement',
      request,
      metadata || {},
      methodDescriptor_RequirementService_StreamRequirement);
};


module.exports = proto.marginpb;

